export default "__VITE_ASSET__C3CGqqLq__"